<template>
    <div id="requestViewer" class="base">
        <div v-if="isloading" id="item-contens">
        </div>
        <div v-else-if="isQueryError" id="item-contens" style="width: 600px;">
            <div class="title-area">
                <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>    
                <div style="font-size: 24px; color: whitesmoke"></div>
            </div>
            <div class="card-content">
                <div style="font-size: 20px; color: whitesmoke">URLエラー</div>
                <div style="color: whitesmoke">
                    指定されたページはURLが間違っているか、有効期限が切れています。
                </div>
            </div>
        </div>
        <div v-else>
            <login></login>
        </div>
    </div>
</template>

<script>
import login from '@/components/mock/login';

export default {
  name: "IntroductionReceive",
  data() {
    return {
        data:{},
        isloading: true,
        isQueryError: true,
    };
  },
  methods: {
  },
  computed: {
  },
  mounted: function(){
    //keyの検証
    try {
        this.$store.dispatch("verifyKeyForIntroductionRequest", {
            query: this.$route.query.query
        }).then(result => {
            if(result != null && result.status === 200 ) {
                this.isQueryError = false
            }
            this.isloading = false;
            if (this.isQueryError) {
                document.documentElement.style.background = "rgb(0, 114, 218)";
            }
        }).catch(error => {
            this.isloading = false;
            if (this.isQueryError) {
                document.documentElement.style.background = "rgb(0, 114, 218)";
            }
        });
    } catch(err){
        this.isloading = false;
    }
  },
  components: {
    login: login,
},
};
</script>
<style lang="scss" scoped>
.base {
    padding-bottom: 50px;
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.card-content {
    border-color: whitesmoke !important;
    margin-bottom:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/introduction/IntroductionReceive.vue